// Eingebetteter Betrieb: der Tresor laeuft als Tab im Datenputzer-Dashboard, aber weiter auf
// seinem eigenen Ursprung tresor.datenputzer.de. Diese Grenze ist der Sinn der Sache: das
// Dashboard laedt Fremdskripte (Stripe, Google-Login) und erlaubt Inline-Code; nichts davon
// kann in diesen Rahmen hineingreifen und den Tresorschluessel benutzen.
//
// Die Schnittstelle zum Dashboard ist absichtlich klein und nur fuer Bedienung:
//   Tresor -> Dashboard: Zustand (gesperrt/offen, Zugang ja/nein), Speicherstand als Zahlen,
//                        "Uploads laufen", Wunsch nach Seitenwechsel (nur Datenputzer-Adressen),
//                        Wunsch nach Abmelden
//   Tresor -> Dashboard: ausserdem die Inhaltshoehe (der Rahmen waechst mit, gescrollt wird die Seite)
//   Dashboard -> Tresor: Farbschema, "sperren", sichtbarer Ausschnitt (fuer Dialoge und Meldungen)
// Nie ueber die Grenze: Schluessel, Passwort, Datei- und Ordnernamen, Inhalte, signierte URLs.
// Das Dashboard kann im Tresor nichts ausloesen ausser Sperren (nimmt Rechte weg, gibt keine).

const PARENT_ORIGIN = 'https://datenputzer.de';

export const IS_EMBEDDED =
  typeof window !== 'undefined' &&
  /^\/einbettung\/?$/.test(window.location.pathname) &&
  window.parent !== window;

export function tellParent(type, data = {}) {
  if (!IS_EMBEDDED) return;
  window.parent.postMessage({ source: 'tresor', type, ...data }, PARENT_ORIGIN);
}

/** Seitenwechsel: eingebettet bittet der Tresor das Dashboard darum, sonst wie bisher. */
export function navigateTop(url, { replace = true } = {}) {
  if (IS_EMBEDDED) {
    tellParent('navigate', { url: new URL(url, window.location.href).href });
    return;
  }
  if (replace) window.location.replace(url);
  else window.location.href = url;
}

let onLockRequest = null;
export function setEmbedLockHandler(fn) {
  onLockRequest = typeof fn === 'function' ? fn : null;
}

if (IS_EMBEDDED) {
  document.documentElement.setAttribute('data-embedded', '1');
  window.addEventListener('message', (event) => {
    if (event.origin !== PARENT_ORIGIN || event.source !== window.parent) return;
    const msg = event.data || {};
    if (msg.source !== 'datenputzer') return;
    if (msg.type === 'theme' && (msg.theme === 'light' || msg.theme === 'dark')) {
      document.documentElement.setAttribute('data-parent-theme', msg.theme);
      document.documentElement.setAttribute('data-vault-theme', msg.theme);
    } else if (msg.type === 'lock' && onLockRequest) {
      onLockRequest();
    } else if (msg.type === 'viewport') {
      // Welcher Teil des (langen) Rahmens gerade im Fenster zu sehen ist. Dialoge und Meldungen
      // haengen sich daran, sonst laegen sie mitten im Rahmen, womoeglich ausserhalb des Bildes.
      const root = document.documentElement.style;
      const num = (v, d) => (Number.isFinite(v) && v >= 0 ? v : d);
      root.setProperty('--embed-top', `${num(msg.top, 0)}px`);
      root.setProperty('--embed-vh', `${num(msg.vh, window.innerHeight)}px`);
      root.setProperty('--embed-min', `${num(msg.minHeight, 0)}px`);
    }
  });
  // Links auf andere Tresor-Seiten (Doku, Nachpruefen, AGB) duerfen nicht im Rahmen oeffnen:
  // diese Seiten verbieten das Einbetten (frame-ancestors 'none'), der Rahmen bliebe leer.
  // Also in einem neuen Fenster. Sprungmarken innerhalb der Seite bleiben, wie sie sind.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, window.location.href);
    if (url.protocol === 'blob:' || url.protocol === 'data:') return;
    if (url.origin === window.location.origin && url.pathname === window.location.pathname) return;
    event.preventDefault();
    window.open(url.href, '_blank', 'noopener');
  }, true);

  // Inhaltshoehe melden, sobald sie sich aendert (Ordner wechseln, Dateien laden, Dialog im Fluss).
  let lastHeight = 0;
  const reportHeight = () => {
    const root = document.getElementById('root');
    const h = Math.ceil(root ? root.getBoundingClientRect().height : document.documentElement.scrollHeight);
    if (h > 0 && Math.abs(h - lastHeight) > 1) {
      lastHeight = h;
      tellParent('height', { height: h });
    }
  };
  if (typeof ResizeObserver === 'function') {
    const ro = new ResizeObserver(reportHeight);
    const start = () => { const r = document.getElementById('root'); if (r) ro.observe(r); reportHeight(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  tellParent('ready');
}
